import React, { useContext, useEffect, useState } from "react";
import { Store } from "../Store";

import {
  addToOrder,
  clearOrder,
  listCategories,
  listProducts,
  removeFromOrder,
  getUserData,
  createOrder,
  setPaymentType,
  generateQrCode,
  getCheckoutUrl,
  updateOrder,
  getTableOrder,
  getTableDetails
} from "../actions";
import {FETCH_ORDER_SUCCESS} from "../constants"
import {
  Box,
  CircularProgress,
  Dialog,
  Slide,
} from "@material-ui/core";
import {
  Button,
 
} from "@material-ui/core";
import BackButton from '../components/Back_Button';
import { useStyles } from "../styles";
import CartReview from "../components/Cart_Review";
import OrderCustomize from "../components/Order_Customize";
import CartButton from "../components/Cart_Button";
import Header from '../components/Header';
import Categories from '../components/Categories';
import ProductList from '../components/Product_List';
import config, { getParameterByName, merchantCode } from "../Configs";

import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import { useIntl } from "react-intl";
import toast, { Toaster } from 'react-hot-toast';
import { onValue, ref } from "firebase/database";
import { db } from "../utils/fbDetails";

const notify = (msg) => toast.success(msg,{
  duration: 10000,
  position: 'bottom-center',icon: '👏'});


export default function OrderScreen(props) {
  const styles = useStyles();
  const { formatMessage: t, locale, setLocale } = useIntl();
  const { state, dispatch } = useContext(Store);
  const { categories, loading, error } = state.categoryList;
  const { table }=state;
  let {customizeInWizard, themeColor,themeTxtColor} = state;
 
  const [orderItem, setOrderItem] = useState(null);
  const [isBackPin, setBackPin] = useState(false);
  const [pin, setPin] = useState("");
  let isVerticalScreen= false;
  if (window.innerHeight > window.innerWidth) {
    isVerticalScreen = true;
  }
  let pgSets = {customizeInWizard, themeColor,themeTxtColor,isVerticalScreen};
  const {
    products,
    loading: loadingProducts,
    error: errorProducts,
  } = state.productList;

  const { orderItems, itemsCount, totalPrice, taxPrice, orderType } =
    state.order;
  const [quantity, setQuantity] = useState(1);
  const [selectedCat, setSelectedCat] = useState("");

  //const [isVegOnly, setIsVegOnly] = useState(false);

  //dialogs state
  const [isCustomizeOpen, setIsCustomizeOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [existingData,setExistingData]= useState();
  const baseURL = config.baseURL;
 
  const tableNumber = getParameterByName("tableNumber");
  console.log('tableNumber=======================', tableNumber);
  let filteredProducts = [];
  if (products) {
    filteredProducts = products.filter (
      (p) =>( p.inStock) 
    );
  }

  let { setting } = state.userSetting;
  let { userInfo } = state.userData;
   let isPaymentAllowed = setting ? setting.isPaymentAllowed :false;
  const selectedCurrency = state.selectedCurrency;
  console.log(orderType);
  if (setting) {
    let body = document.getElementsByTagName("body");
    //body[0].style.backgroundColor = setting.color_tirnary;
    setTimeout(() => {
      let textcolor = document.getElementById("title1");
      textcolor.style.color = setting.color_primary;
    }, 10);
  }

 useEffect(() => {
    if(state.userData && state.userData.userInfo && state.userData.userInfo.merchantCode){
      let merchCode =state.userData.userInfo.merchantCode;
 console.log('++++FB REGISTERED*********************',merchCode);

 const query = ref(db, "products/"+merchCode);
                 onValue(query, (snapshot) => {
                  console.log('-------------new order');
                const data = snapshot.val();
                  refreshAll();
                setIsCustomizeOpen(false);
                },(error) => {
              console.error(error);
}); 

               }
  }, [state.userData]);


 const refreshAll =() =>{
    getTableDetails(dispatch,tableNumber);
     listCategories(dispatch);
     listProducts(dispatch);
 }

  const closeHandler = () => {
    setIsCustomizeOpen(false);
    setIsCartOpen(false);
  };

  const vegHandler = () => {
    console.log(products);
    //setIsVegOnly(!isVegOnly);
  };

const categoryClickHandler = (cat) => {
      console.log(cat);
      setSelectedCat(cat)
}

const addToOrderHandler = (customInstr) => {

  //Set price if variety price availabe
  let varName = Object.keys(orderItem.sub_pro.variety);
  orderItem.price = varName.length
      ? parseFloat(orderItem.sub_pro.variety[varName[0]])
      : orderItem.price;

  customInstr.length&& orderItem.sub_pro.cookInstructions.push(customInstr);
  console.log(orderItem);
  
  addToOrder(dispatch, { ...orderItem, quantity });

  setIsCustomizeOpen(false);
  setOrderItem(null);
  setQuantity(1);
  let isEditOrdItem=orderItems.filter(om=> om.id==orderItem.id).length;
  isEditOrdItem && setIsCartOpen(true);

  };



const productClickHandler = (p,isEditOrder) => {
    console.log('---produc click');
    if(!isEditOrder){
    p['sub_pro']={};
    p.sub_pro['addons'] = [];
    p.sub_pro['variety'] = {};
    p.sub_pro['cookInstructions'] =[];
    }
    setOrderItem(p);
    setIsCustomizeOpen(true);
  };

  const removeOrderItm = () => {
    setIsCustomizeOpen(false);
    setOrderItem(null);
    removeFromOrder(dispatch, orderItem);
    getTableDetails(dispatch,tableNumber);
  };

   const procedToCheckoutHandler = () => {
    let ord = { ...state.order };
    ord.tableId = table.details && table.details.id;
    ord.userId= merchantCode;
    ord.number= table.details && table.details.number;
    ord.tableNumber= table.details && table.details.number;
    ord.orderItems = ord.orderItems.map((orderItem) => ({
      ...orderItem,
      status: orderItem.status ? orderItem.status : "inProgress",
      sub_pro:
        typeof orderItem.sub_pro !== "string"
          ? JSON.stringify(orderItem.sub_pro)
          : orderItem.sub_pro,
    }));

    if (state.order && state.order.orderId) {
      //console.log("newOrder");
      updateOrder(dispatch, ord, state.order.orderId);
    } else {
      createOrder(dispatch, ord);
      localStorage.removeItem("newOrder");
    }
    // if (isPaymentAllowed) {
    //   props.history.push(
    //     "/select-payment?" + window.location.href.split("?")[1]
    //   );
    // } else {
    //   props.history.push("/addmore?" + window.location.href.split("?")[1]);
    // }

    setIsCartOpen(false);
    notify("Your Order is preparing...");
    getTableDetails(dispatch,tableNumber);
  };


  const handleCart = (cartItems) => {
    console.log("Cart");
    if(cartItems==0)return
    setIsCartOpen(true);
  };

  const imageOnErrorHandler = (event) => {
    event.currentTarget.src = "./images/blank.jpg";
  };

  const handleBack =()=>{
    if(isCartOpen||isCustomizeOpen){
        setIsCartOpen(false);
        setIsCustomizeOpen(false);
    }else{
    console.log('bakc lcikc');
    setBackPin(true);
  
    }
  }
  const checkPin = (e)=>{
    if(e.target.value=='2424'){
      localStorage.removeItem('tableId');
      setPin("");
      props.history.push(`/?merchantCode=${getParameterByName("merchantCode")}`);

    }else{
      setPin(e.target.value);
    }
  }

let slideChild=[];
 const isScan = getParameterByName("isScan") && getParameterByName("isScan")=='true';
 
  return (
    <Box className={styles.root} style={{ backgroundColor: "#fff", overflow:'hidden',height:'100vh' }}>
      <Header
      baseURL ={baseURL}
      tableNumber ={tableNumber}
      handleBack ={handleBack}
      getTableDetails={()=>getTableDetails(dispatch,tableNumber)}
      refreshAll = {refreshAll}
      table={table}
      />
      {!isScan && <div style={{
                height: '40px',
                margin:'10px',
                background:'#fff',
                color:"#000",
                position:'absolute',
                bottom:"10px",
                left:"10px",
                zIndex:99999
              }}>
              <BackButton handleClick={handleBack}
          /></div>}
     
      <Box style={{display:'flex',flexDirection:isVerticalScreen?'column':"row"}} id="body_container">
      <Categories 
        categories={categories?categories:[]} 
        baseURL={baseURL}
        selectedCat={selectedCat}
        imageOnErrorHandler={imageOnErrorHandler}
        pgSets={pgSets}
        categoryClickHandler={categoryClickHandler}/>
      <div style={{display:"inline-block",padding:"0px 10px"}}>
      <h2 style={{margin:'0px'}}>{(selectedCat && selectedCat.name) || t({ id: "explore_menu" })}</h2>
      
      <ProductList 
        items={products?products:[]} 
        baseURL={baseURL}
        pgSets={pgSets}
        imageOnErrorHandler={imageOnErrorHandler}
        productClickHandler={productClickHandler}
        categories={categories?categories:[]}
        selectedCat={selectedCat}
        t={t}/>
      </div>
      </Box>

      <Dialog
          onClose={closeHandler}
          aria-labelledby="max-width-dialog-title"
          style={{ backgroundColor: "#FFBC00 !important" }}
          open={isCartOpen||isCustomizeOpen}
          fullWidth={true}
        maxWidth={'xl'}
          
        >
        
         {isCustomizeOpen&& <OrderCustomize 
        orderItem={orderItem}
        setOrderItem={setOrderItem}
        baseURL={baseURL}
        imageOnErrorHandler={imageOnErrorHandler}
        quantity ={quantity}
        categories={categories}
        setQuantity={setQuantity}
        orderItems={orderItems}
        categories={categories}
        items={products?products:[]}
        setIsCustomizeOpen={setIsCustomizeOpen}
        addToOrderHandler={addToOrderHandler}
        removeOrderItm={removeOrderItm}
        t={t}
        />

        }
        {isCartOpen&& <CartReview t={t}  
        orderItems={orderItems}
        setIsCartOpen={setIsCartOpen}
        productClickHandler={productClickHandler}
        categories={categories}
        table={table.details}
        previewOrderHandler={procedToCheckoutHandler}
        history={props.history}
        baseURL={baseURL}
        notify ={notify}
        getTableDetails={()=>getTableDetails(dispatch,tableNumber)}
        />}


        </Dialog>

        <CartButton itemsCount={itemsCount} 
        handleCart={handleCart}
        setIsCartOpen={setIsCartOpen}/>
        <Dialog onClose={closeHandler}
     
          open={isBackPin}
          fullWidth={false}
        maxWidth={'md'}
        style={{padding:"20px!important"}}>

        <h1 style={{padding:"10px"}}>Enter Pin</h1>
        <input value={pin} style={{width:"200px",margin:"20px",fontSize:"2.2em",textAlign:"center"}} onChange={checkPin} />
        <Button style={{padding:"10px"}} onClick={()=>setBackPin(false)}>Close</Button>
        </Dialog>     

         <Toaster />    
      </Box>
  );
}
